module.exports = __webpack_public_path__ + "img/guanyu_pic.ee06a1a5.png";